import httpService from '@/utils/request'
import { contextPath } from '@/config/'

// 搜索
export const searchThenGetTaskIdApi = (searchStr, pn) => {
  return httpService({
    url: contextPath + '/spider/keyword/item/addSearch',
    method: 'get',
    params: {
      searchStr,
      pn
    }
  })
}

export const getSearchResultApi = (params) => {
  return httpService({
    url: contextPath + '/parse/failed/web/info/keyword',
    method: 'get',
    params
  })
}